<template>
  <div id="privacy_container">
    <LandingPrivacy/>
    <b-container
      class="body"
      style="flex: 1; height: 100%;"
    >
    <router-view/>
    </b-container>
    <Footer/>
  </div>
</template>

<script>
import LandingPrivacy from '@/components/LandingPrivacy'
import Footer from '@/components/Footer'
export default {
  name: 'privacy',
  components: {
    Footer,
    LandingPrivacy
  }
}
</script>
<style>
.body {
  padding-left: 0px;
  padding-right: 0px;
  overflow-y: auto;
}

#privacy_container{
  height: 100%;
  display: flex;
  flex-direction: column;
}

</style>
